import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {useSettings} from '@common/core/settings/use-settings';

/**
 * Content Studio UI gate: settings.studio_enabled (STUDIO_ENABLED).
 * Added: 2026-09-11. Changed: 2026-09-22 — env flag instead of APP_ENV.
 */
export function isStudioFeatureEnabledFromFlag(
  enabled?: boolean | null,
): boolean {
  return enabled === true;
}

export function isStudioFeatureEnabled(): boolean {
  try {
    return isStudioFeatureEnabledFromFlag(
      getBootstrapData()?.settings?.studio_enabled,
    );
  } catch {
    return false;
  }
}

export function useIsStudioFeatureEnabled(): boolean {
  const {studio_enabled} = useSettings();
  return isStudioFeatureEnabledFromFlag(studio_enabled);
}
